(() => {
  const HEADER_SELECTOR = "header[data-transparent-header]";
  const INTERACTION_MENU_SELECTOR = ".nav > li.active, .dropdown.active, .menu-shop.active";
  const INTERACTION_SEARCH_SELECTOR = ".search.on";

  function initHeaderTransparency() {
    const header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;

    const isEnabled = header.dataset.transparentEnabled === "true";
    const transparentForeground = header.dataset.transparentFg === "black" ? "black" : "white";

    if (!isEnabled) {
      header.classList.remove("header--transparent-active", "header--fg-white", "header--fg-black");
      return;
    }

    const bannerSelector = header.dataset.transparentTarget;
    const banner = document.querySelector(bannerSelector);

    const state = {
      isHovering: false,
      isMenuOpen: false,
      isSearchOpen: false,
      isOverBanner: false,
    };

    let rafId = null;
    const scrollingElement = document.scrollingElement || document.documentElement;

    const updateInteractionState = () => {
      state.isMenuOpen = Boolean(header.querySelector(INTERACTION_MENU_SELECTOR));
      state.isSearchOpen = Boolean(header.closest("site-header")?.querySelector(INTERACTION_SEARCH_SELECTOR));
    };

    const updatePositionState = () => {
      if (!banner) {
        state.isOverBanner = false;
        return;
      }

      const headerRect = header.getBoundingClientRect();
      const bannerRect = banner.getBoundingClientRect();
      state.isOverBanner =
        headerRect.top >= bannerRect.top && bannerRect.bottom >= headerRect.bottom;
    };

    const applyHeaderState = () => {
      const hasInteractionLock = state.isHovering || state.isMenuOpen || state.isSearchOpen;
      const canBeTransparent = state.isOverBanner;
      const shouldBeTransparent = !hasInteractionLock && canBeTransparent;

      header.classList.toggle("header--transparent-active", shouldBeTransparent);
      header.classList.toggle("header--fg-white", shouldBeTransparent && transparentForeground === "white");
      header.classList.toggle("header--fg-black", shouldBeTransparent && transparentForeground === "black");
    };

    const scheduleStateUpdate = () => {
      if (rafId !== null) return;
      rafId = window.requestAnimationFrame(() => {
        rafId = null;
        updateInteractionState();
        updatePositionState();
        applyHeaderState();
      });
    };

    header.addEventListener("mouseenter", () => {
      state.isHovering = true;
      scheduleStateUpdate();
    });

    header.addEventListener("mouseleave", () => {
      state.isHovering = false;
      scheduleStateUpdate();
    });

    // desktop use window and mobile use document body
    window.addEventListener("scroll", scheduleStateUpdate, { passive: true });
    document.addEventListener("scroll", scheduleStateUpdate, { passive: true });
    document.body.addEventListener("scroll", scheduleStateUpdate, { passive: true });
    if (scrollingElement && scrollingElement !== document.body) {
      scrollingElement.addEventListener("scroll", scheduleStateUpdate, { passive: true });
    }
    window.addEventListener("resize", scheduleStateUpdate);
    document.addEventListener("click", scheduleStateUpdate, true);
    document.addEventListener("keyup", scheduleStateUpdate, true);

    const observer = new MutationObserver(scheduleStateUpdate);
    observer.observe(header.closest("site-header") || header, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "aria-expanded"],
    });

    if (banner) {
      const intersectionObserver = new IntersectionObserver(() => {
        scheduleStateUpdate();
      });
      intersectionObserver.observe(banner);
    }

    scheduleStateUpdate();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeaderTransparency);
    return;
  }

  initHeaderTransparency();
})();
